/* globals Class, jui */
window.lp.pom.ElementView = Class.create( jui.Component, {
  initialize: function($super, element, options){
    options = options || {};
    this.element = element;
    // Object.extend(element, lp.pom.ElementViewHandlers);
    options.attributes = {className:'lp-element '+element.type};
    $super(options);
    this.e.id = this.element.id;
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/element_view.js
// module id = 479
// module chunks = 0 1